
const common = {
  loading: 'Yükleniyor...',
  save: 'Kaydet',
  cancel: 'İptal',
  delete: 'Sil',
  edit: 'Düzenle',
  close: 'Kapat',
  confirm: 'Onayla',
  back: 'Geri',
  next: 'İleri',
  previous: 'Önceki',
  search: 'Ara',
  filter: 'Filtrele',
  sort: 'Sırala',
  export: 'Dışa Aktar',
  import: 'İçe Aktar',
  print: 'Yazdır',
  download: 'İndir',
  upload: 'Yükle',
  submit: 'Gönder',
  reset: 'Sıfırla',
  clear: 'Temizle',
  select: 'Seç',
  selectAll: 'Tümünü Seç',
  deselectAll: 'Tümünü Kaldır',
  yes: 'Evet',
  no: 'Hayır',
  ok: 'Tamam',
  error: 'Hata',
  success: 'Başarılı',
  warning: 'Uyarı',
  info: 'Bilgi',
  required: 'Zorunlu',
  optional: 'İsteğe Bağlı',
  theme: {
    light: 'Açık Tema',
    dark: 'Koyu Tema',
    toggle: 'Tema Değiştir'
  },
  language: {
    turkish: 'Türkçe',
    english: 'English',
    change: 'Dil Değiştir'
  },
  home: {
    title: 'İş Sağlığı ve Güvenliği Yönetim Sistemi',
    subtitle: 'Çalışan sağlığını koruyun, iş güvenliğini artırın',
    cta: 'Hemen Başlayın',
    hero: {
      title: 'İş Sağlığı ve Güvenliği Yönetim Sistemi',
      subtitle: 'Çalışan sağlığını koruyun, iş güvenliğini artırın ve iş yerinizdeki riskleri minimize edin. Kapsamlı sağlık takibi ve güvenlik yönetimi ile işletmenizi geleceğe hazırlayın.',
      login: 'Giriş Yap',
      register: 'Kayıt Ol'
    },
    features: {
      title: 'Temel Özellikler',
      subtitle: 'İş sağlığı ve güvenliği süreçlerinizi dijitalleştirin ve çalışanlarınızın sağlığını koruyun'
    }
  },
  features: {
    health: {
      title: 'Sağlık İzleme',
      desc: 'Çalışanların sağlık durumunu takip edin, periyodik muayeneleri yönetin'
    },
    safety: {
      title: 'Güvenlik Yönetimi',
      desc: 'İş güvenliği protokollerini uygulayın, riskleri minimize edin'
    },
    hygiene: {
      title: 'Hijyen Kontrolü',
      desc: 'İş yeri hijyen standartlarını koruyun ve takip edin'
    },
    analysis: {
      title: 'Risk Analizi',
      desc: 'Detaylı risk analizleri yapın, önleyici tedbirler alın'
    },
    warning: {
      title: 'Erken Uyarı',
      desc: 'Potansiyel tehlikeleri önceden tespit edin ve uyarı alın'
    },
    reporting: {
      title: 'Raporlama',
      desc: 'Kapsamlı raporlar oluşturun, yasal gereklilikleri karşılayın'
    }
  },
  footer: {
    company: 'İş sağlığı ve güvenliği alanında lider teknoloji çözümleri sunuyoruz.',
    rights: 'Tüm hakları saklıdır.'
  },
  auth: {
    login: {
      title: 'Giriş Yap',
      subtitle: 'Hesabınıza giriş yapın',
      email: 'E-posta',
      password: 'Şifre',
      submit: 'Giriş Yap',
      forgot: 'Şifremi Unuttum',
      register: 'Hesabınız yok mu? Kayıt olun'
    },
    register: {
      title: 'Kayıt Ol',
      subtitle: 'Yeni hesap oluşturun',
      email: 'E-posta',
      password: 'Şifre',
      confirmPassword: 'Şifre Tekrar',
      submit: 'Kayıt Ol',
      login: 'Zaten hesabınız var mı? Giriş yapın'
    },
    logout: 'Çıkış Yap'
  },
  dashboard: {
    title: 'Yönetim Paneli',
    welcome: 'Hoş geldiniz',
    overview: 'Genel Bakış',
    users: 'Kullanıcılar',
    reports: 'Raporlar',
    incidents: 'Olaylar',
    settings: 'Ayarlar',
    stats: {
      totalUsers: 'Toplam Kullanıcı',
      totalReports: 'Toplam Rapor',
      pendingApprovals: 'Bekleyen Onay',
      activeIncidents: 'Aktif Olay'
    },
    recentActivities: 'Son Aktiviteler',
    systemStatus: 'Sistem Durumu'
  }
};

export default common;
